import { Button, Typography } from '@mui/material';
import { Box, useMediaQuery, useTheme } from '@mui/system';
import React, { useEffect, useState } from 'react';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import HeaderFilters from 'src/components/header-filters/header-filter';
import { useJobsData } from 'src/context/job-context';
import { useVisibility } from 'src/context/visibility-context';
import { paths } from 'src/routes/paths';
import MapPageView from 'src/sections/overview/map/view';
import axios, { endpoints } from 'src/utils/axios';

const SalesMapView = () => {
  const [IsHeatMap, setIsHeatMap] = useState(false);
  const { updateJobsData, jobsData } = useJobsData();
  const [myJobs, setMyJobs] = useState(false);
  const { myJob } = useJobsData();
  const { showMapAndList } = useVisibility();

  const theme = useTheme();
  const isLaptopMode = useMediaQuery(theme.breakpoints.up('md'));
  const isMobileMode = useMediaQuery(theme.breakpoints.down('sm'));

  const getJobsList = async () => {
    const apiData = {};
    try {
      const { data } = await axios.post(endpoints.getJobs.list, apiData);
      if (data.data.length > 0) {
        updateJobsData({ jobs: data.data });
      }
      return data;
    } catch (error) {
      console.error('Error fetching jobs:', error);
      throw error;
    }
  };

  useEffect(() => {
    getJobsList();
  }, []);

  return (
    <>
      {isLaptopMode && (
        <CustomBreadcrumbs
          gutter={false}
          heading="Sales Map"
          links={[{ name: '', href: paths.dashboard.root }]}
          sx={{
            mb: { xs: -2, md: 4 },
            ml: { xs: 3, md: 5 },
          }}
        />
      )}
      {!showMapAndList && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            p: 1.4,
            // pt: 1,
            gap: 2,
            position: isMobileMode ? 'sticky' : 'static',
            top: 63,
            zIndex: 1100,
            bgcolor: 'rgba(255, 255, 255, 0.7)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            boxShadow: isMobileMode ? '0px 2px 4px rgba(0,0,0,0.1)' : 'none',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {isMobileMode &&  <Typography variant='h4' sx={{width: '100%', pl: 1}}>Sales Map</Typography>}
          <HeaderFilters
            IsHeatMap={IsHeatMap}
            setIsHeatMap={setIsHeatMap}
            myJobs={myJob}
            setMyJobs={setMyJobs}
          />
          </Box>
        </Box>
      )}
      <Box
        sx={{
          p: !showMapAndList ? 2 : 0,
        }}
      >
        <MapPageView />
      </Box>
    </>
  );
};

export default SalesMapView;
